import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Member } from '../../models/member';

@Injectable({
  providedIn: 'root'
})

export class ReportService {

  constructor(private http: HttpClient) { }

  GetGoodStanding1Report(input: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    input.memberYear = input.memberYear.year;
    return this.http.post<any>(environment.apiUrl + 'Report/GoodStanding1ReportAsync', input, httpOptions);
  }

  GetGoodStanding2Report(input: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    input.officeId = input.officeId.officeId;
  
    input.memberYear = input.memberYear.year;
    return this.http.post<any>(environment.apiUrl + 'Report/GoodStanding2ReportAsync', input, httpOptions);
  }

  GetOfficeList() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Report/GetOfficeList', httpOptions);
  }

  getMemberReportAsync(memberdata: Member) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Report/GetMemberReportAsync', JSON.stringify(memberdata), httpOptions);
  }

}
